import React from 'react';
import type { Block } from '../../../types/parcours';

interface ImageBlock extends Block {
  type: 'image';
  url?: string;
  alt?: string;
  caption?: string;
  align?: 'left' | 'center' | 'right';
  maxWidth?: string;
}

interface Props {
  block: ImageBlock;
}

const alignClass: Record<string, string> = {
  left: 'mr-auto',
  center: 'mx-auto',
  right: 'ml-auto',
};

export default function ImageBlock({ block }: Props) {
  if (!block.url) return null;

  const align = block.align ?? 'center';

  return (
    <figure className="my-6">
      <img
        src={block.url}
        alt={block.alt ?? ''}
        loading="lazy"
        decoding="async"
        className={`rounded-xl w-full object-cover ${alignClass[align]}`}
        style={block.maxWidth ? { maxWidth: block.maxWidth } : undefined}
      />
      {block.caption && (
        <figcaption className="mt-2 text-sm text-neutral-500 text-center">
          {block.caption}
        </figcaption>
      )}
    </figure>
  );
}
